<template>
  <main-layout class="batch-print" page-title="打印记录">
    <div slot="main-content" class="main-content">
      <div class="page">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>我的农场信息</span>
          </div>
          <div class="card-body">
            <div>
              <div class="name-title">
                企业名称： {{ companyInfo.companyName }}
              </div>
              <div>农场名称： {{ farmInfo.farmName }}</div>
            </div>
            <div></div>
          </div>
        </el-card>
        <template v-if="list.length">
          <el-card
            class="box-card"
            v-for="item in list"
            :key="item.stationFarmRefId"
          >
            <div slot="header" class="clearfix">
              <span>{{ item.stationName }}</span>
            </div>
            <div class="card-body">
              <div>
                <div class="name-title">站点地址： {{ item.address }}</div>
                <div>联系电话： {{ item.phone }}</div>
              </div>
              <div>
                <el-button
                  type="primary"
                  :plain="!item.defaultChoose"
                  @click="chooseStation(item)"
                >
                  {{ item.defaultChoose ? "已选" : "选择" }}
                </el-button>
                <el-button type="danger" @click="unBind(item.stationFarmRefId)"
                  >解绑</el-button
                >
              </div>
            </div>
          </el-card>
        </template>
        <div class="noDataImg" v-else>
          <div class="imgNo">
            <img
              src="@/assets/images/aviatFarmingList/batch-nodata.png"
              alt=""
            />
          </div>
          <p style="color: #333; margin-bottom: 20px">
            暂未关联站点，请在神农口袋APP端扫码关联
          </p>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import {
  chooseDefaultStationApi,
  getCertificateStationList,
  unBindStationApi,
} from "@/api/request/snkd.produce";
// import sameIn from "@/mixins/listsdetails";
// import { debounce } from "@/utils";
import { mapActions } from "vuex";
import { getStorage } from "@/utils/storage";

const farmInfo = getStorage("FARMINFO");
const companyInfo = getStorage("COMPANYINFO");
export default {
  name: "batchPrint",
  // mixins: [sameIn],
  components: {
    MainLayout,
  },
  data() {
    return {
      list: [],
      tableLoading: false,
      isPrint: false,
      farmInfo,
      companyInfo,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    getList() {
      getCertificateStationList({}).then(({ obj }) => {
        this.list = obj;
      });
    },
    unBind(stationFarmRefId) {
      this.$confirm("此操作将解绑该站点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await unBindStationApi({
            stationFarmRefId,
          });
          this.getList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async chooseStation(item) {
      const { stationFarmRefId, defaultChoose } = item;
      if (!defaultChoose) {
        await chooseDefaultStationApi({ stationFarmRefId });
        this.getList();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.batch-print {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .page {
      min-height: 0;
      flex: 1;
      padding: 40px 30px;
      ::v-deep .el-card {
        margin-bottom: 20px;
        border-radius: 20px;
        .el-card__header {
          color: #666;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
      ::v-deep .el-button {
        width: 120px;
      }
      .card-body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        .name-title {
          margin-bottom: 14px;
        }
      }
    }
  }
}
</style>
